import { useMyBucket } from '../../../../Hooks/Features/Pocker/useMyBucket';
import { Calendar } from 'primereact/calendar';
import { MultiSelect } from 'primereact/multiselect';
import CommonGrid from '../../../../components/CommonCompo/CommonGrid/CommonGrid';
import PanelHeaderTemplate from '../../../../components/CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dialog } from 'primereact/dialog';
import Logwork from '../../../../components/Dashboard/WorklogCalendar/Logwork';
import { DateObject } from 'react-multi-date-picker';
import { useCommon } from "../../../../Hooks/Common/useCommon";
import { useCalender } from "../../../../Hooks/Features/Dashboard/useCalender";
import UpdateTaskStatus from '../../../../components/Poker/UpdateTaskStatus';
import { useTheme } from '../../../../context/ThemeContext';
import { Tooltip } from 'primereact/tooltip';
import CommonFilterDropdown from '../../../../components/CommonCompo/CommonFilterDropdown/CommonFilterDropdown';
import TaskDetailsPopup from '../../../../components/TaskList/TaskDetailsPopup';

function MyBucket() {
    const { theme } = useTheme();
    const { checkPermission } = useCommon();
    const { handleDateSelected, tableData, calendarDate, getTimesheetCalendarSummary, setFilterValue, filterValue } = useCalender()
    const { tagRef, options, showTimesheet, rowData, columns, loader, filterValues, setFilterValues, clickedRowTaskId, setShowTimesheet, popupValue, setPopupValue, updateReviewer, selectedTab, setSelectedTab, workspaceRowData, tooltip, handlePick, handleApiCall, taskDetailsPopup, setTaskDetailsPopup } = useMyBucket({ fromTaskList: false });

    const tabs = [
        { key: "my_assigned", label: "My Assigned" },
        { key: "workspace", label: "Workspace" },
    ]

    return (
        <div ref={() => checkPermission("MyBucket", tagRef)}>
            <div ref={tagRef} id='{"tabname":"My bucket", "data": "agileplanning_estimation_tab"}' >
                <div className="d-flex justify-content-between align-items-center my-3 px-3 gap-3">
                    <div className={`tab-menu ${theme === "dark" ? "dark" : ""}`}>
                        {tabs?.map(item => (
                            <div key={item?.key} className={`tab-menu-item ${item?.key === selectedTab ? `active${theme === "dark" ? "-dark" : ""}` : ""}`} onClick={() => { if (selectedTab !== item?.key) { setSelectedTab(item?.key); setFilterValues((prev) => ({ ...prev, apiCall: true })) } }}>
                                <FontAwesomeIcon icon={item?.key === "my_assigned" ? "fa-solid fa-user" : "fa-solid fa-arrow-pointer"} /> {item?.label}
                            </div>
                        ))}
                    </div>
                    <div className="d-flex gap-2 align-items-center flex-grow-1 justify-content-end">
                        <div style={{ width: "160px" }}>
                            <CommonFilterDropdown
                                fields={[
                                    { key: "projects", label: "Projects", col: 12 },
                                ]}
                                filterValues={filterValues}
                                setFilterValues={setFilterValues} />
                        </div>
                        <div style={{ width: "160px" }}>
                            <MultiSelect
                                className="input-dd mb-0"
                                placeholder="Epic"
                                options={options?.epicList}
                                optionLabel="issue_summary"
                                optionValue="issue_id"
                                value={filterValues.epic}
                                onChange={(e) => { setFilterValues((prev) => ({ ...prev, epic: e.value, isChange: true })) }}
                                onHide={() => { if (filterValues?.isChange) { handleApiCall(); setFilterValues((prev) => ({ ...prev, isChange: false })) } }}
                                panelHeaderTemplate={(options) => PanelHeaderTemplate(options, "epic", filterValues.epic, (value) => setFilterValues(prev => ({ ...prev, epic: value, isChange: true })), () => { })}
                                filter
                                filterInputAutoFocus
                            />
                        </div>
                        <div style={{ width: "140px" }}>
                            <input
                                className="input-dd w100 mb-0"
                                placeholder="Task Id..."
                                value={filterValues?.issueKey}
                                onChange={(e) => { setFilterValues(prev => ({ ...prev, issueKey: e.target.value, isChange: true })); }}
                                onBlur={() => { if (filterValues.isChange) { handleApiCall(); setFilterValues(prev => ({ ...prev, isChange: false })) } }}
                            />
                        </div>
                        {selectedTab === "my_assigned" && (
                            <div className="inspectra-calendar" style={{ width: "140px" }}>
                                <Calendar
                                    view="month"
                                    className="input-dd"
                                    dateFormat="MM yy"
                                    placeholder="Select Month"
                                    value={filterValues.date}
                                    onChange={(e) => { setFilterValues(prev => ({ ...prev, date: e.value, isChange: true })); }}
                                    onBlur={() => { if (filterValues.isChange) { handleApiCall(); } setFilterValues(prev => ({ ...prev, isChange: false })) }}
                                />
                            </div>
                        )}
                    </div>
                    <div className="d-flex justify-content-end align-items-center gap-2">
                        {selectedTab === "workspace" && (
                            <button className="sk-btn sk-btn-primary rounded" onClick={() => { handlePick() }} title="Pick Selected">
                                <FontAwesomeIcon icon="fa-solid fa-plus" /> Pick Selected
                            </button>
                        )}
                        <button data-icon-only="true" data-action-type="default" onClick={() => { handleApiCall() }} title="Refresh">
                            <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
                        </button>
                    </div>
                </div>
                <div className='w100 mt-2' style={{ height: "calc(100vh - 120px)", overflow: "auto" }}>
                    <CommonGrid columns={selectedTab === "my_assigned" ? columns?.myAssigned : columns?.workspace} data={selectedTab === "my_assigned" ? rowData : workspaceRowData} loader={loader} headerHeight={50} expandAll={true} />
                </div>
                <Dialog draggable={false} visible={showTimesheet} onHide={() => { setFilterValue({ hoveredRange: [new DateObject(), new DateObject()] }); setShowTimesheet(false); }}
                    header={`${calendarDate?.toLocaleString('en-GB')?.split(",")[0]?.split("/")?.join("-")}  [ Hours: ${[calendarDate?.toLocaleString("en-GB")?.split(",")[0]?.split("/")?.reverse()?.join("-")]?.loginfo || 0}h]`} className='wc-timesheet-dialog p-0' modal style={{ width: "95vw", height: "90vh" }} resizable={false}>
                    <Logwork isMyBucket={true} handleDateSelected={handleDateSelected} onSave={() => getTimesheetCalendarSummary()}
                        closePopup={() => { setShowTimesheet(false); }} date={calendarDate} timesheetData={tableData} clickedRowTaskId={clickedRowTaskId} setFilterValue={setFilterValue} filterValue={filterValue} />
                </Dialog>
                {
                    popupValue?.show && <UpdateTaskStatus options={options} popupValue={popupValue} setPopupValue={setPopupValue} updateReviewer={updateReviewer} />
                }

                <Tooltip target=".current-bid-tooltip" position="top" escape="false" className="project-glance-tooltip">
                    {tooltip?.currentBid?.percent && <div style={{ fontSize: "0.8rem" }}>
                        <div className="d-flex gap-2 align-items-center fw-bold" style={{ color: "#3d3d3d" }}>
                            <FontAwesomeIcon icon="fa-solid fa-circle-info" />
                            {tooltip?.currentBid?.type}-Bidded
                        </div>
                        <div className="mt-1 text-secondary fw-semibold">This bid is {Math.abs(tooltip?.currentBid?.percent)}% {tooltip?.currentBid?.percent > 0 ? "higher" : "lower"} than your typical average ({tooltip?.currentBid?.avg}h).</div>
                    </div>}
                </Tooltip>

                {taskDetailsPopup?.show &&
                    <Dialog visible={taskDetailsPopup?.show} draggable={false} style={{ height: "85vh", width: "70rem", maxWidth: "70rem" }} className='modal-xlarge task-details' onHide={() => setTaskDetailsPopup((prev) => ({ ...prev, show: false }))}>
                        <TaskDetailsPopup setTaskDetailsPopup={setTaskDetailsPopup} data={taskDetailsPopup?.data || { project_id: 0 }} />
                    </Dialog>
                }
            </div>
        </div>
    );
}

export default MyBucket;

